<template>
	<div class="auth password-request">
		<div class="sk-h1 sk-h1--large">Welcome!</div>
		<div class="sk-note sk-note--margin-l">Forgotten your password? You can request a new one by entering the details below.</div>
		<form @submit.prevent="validateAndSubmit" class="form-auth">
			<div v-if="success">
				<div class="alert alert-success">{{ success }}</div>
				<router-link class="btn btn-primary" :to="{ name: 'AuthLogin' }">{{ $t('base.auth.login') }}</router-link>
			</div>
			<div v-if="!success">
				<input-text v-model="model.email" name="email" placeholder="Email" rules="required|email"/>
				<div class="form-group">
					<button class="btn btn-primary btn-round" type="submit">{{ $t('base.auth.request') }}</button>
				</div>
			</div>
			<span>or</span>
			<router-link :to="{ name: 'AuthRegister'}">{{ $t('base.auth.no_account') }}</router-link>
			<error-box v-if="error" :error="error"/>
		</form>
	</div>
</template>

<script>
export default {
	data () {
		return {
			model: {
				email: ''
			},
			email: '',
			success: '',
			error: null
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.submit()
			})
		},
		submit () {
			this.success = ''
			this.error = ''
			this.$api.auth.passwordRequest(this, this.model).then(response => {
				this.$log.info('user password request', 'auth.passwordRequest OK', response)()
				this.success = response.body.message
			}).catch(errors => {
				this.$log.error('user password request', 'auth.passwordRequest ERROR', errors)()
				this.error = errors
			})
		}
	},
	beforeCreate () {
		this.$title(this.$t('base.auth.request_new_password'))
	}
}
</script>



// WEBPACK FOOTER //
// src/components/auth/AuthPasswordRequest.vue